import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import * as actions from '../actions/tools';
import SearchBox from '../components/SearchBox';

const usersSelector = state =>
  state.map.usersMap;

const searchTextSelector = state =>
  state.tools.searchBoxText;

/*
const usersItemsSelector = createSelector(
  searchTextSelector,
  usersSelector,
  (searchText, users) => Object.keys(users).map(id => users[id]).filter(user => (
    user.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1 ||
    user.groups.filter(group =>
      group.groupname.toLowerCase().indexOf(searchText.toLowerCase()) !== -1).length > 0
  )).slice(0, 7),
);
*/

const usersItemsSelector = createSelector(
  searchTextSelector,
  usersSelector,
  (searchText, users) => Object.keys(users).map(id => {
    const user = users[id]
    let index = user.name.toLowerCase().indexOf(searchText.toLowerCase())
    if (index === -1 && user.groups.filter(group =>
      group.groupname.toLowerCase().indexOf(searchText.toLowerCase()) !== -1).length > 0) {
      index = 100;
    }
    return {
      user,
      index,
    }
  }).filter(({index, user}) => index !== -1).sort((a, b) => a.index - b.index
  ).map(({user}) => user).slice(0, 7),
);


const mapStateToProps = state => ({
  usersItems: usersItemsSelector(state),
  searchText: searchTextSelector(state),
  showDropdown: state.tools.searchBoxDropdown,
});

const mapDispatchToProps = dispatch => ({
  onChange: text => dispatch(actions.setSearchBoxText(text)),
  onSelect: user => dispatch(actions.selectUser(user, null, true)),
  onClear: () => dispatch(actions.selectUser()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchBox);



// WEBPACK FOOTER //
// ./src/containers/SearchBox.js